<template>
  <div>
    <b-modal
      id="applicationInProgressModal"
      title="Merkja umsóknir í vinnslu"
      size="lg"
      lazy
      :no-close-on-backdrop="true"
      ok-title="Merkja í vinnslu"
      cancel-title="Hætta við"
      @ok.prevent="validateBeforeSubmit"
      :ok-disabled="loading || !allNew"
      ref="createModal"
    >
      <div>
        <h5>Veldu starfsstaði til þess að merkja umsóknir á</h5>
        <p><i>Valkvætt að velja hóp í leiðinni</i></p>
        <table class="table white-table">
          <tr>
            <th>Nafn</th>
            <th>Fæðingarár</th>
            <th>Tímabil</th>
            <th>Starfsstaður</th>
            <th>Hópur</th>
            <th></th>
          </tr>
          <tr
            v-for="application in applications"
            :key="application.id"
            :class="{ 'text-danger': application.status !== 'NEW' && application.status !== 'IN_PROGRESS' }"
          >
            <td>{{ application.name }}</td>
            <td>{{ application.birthYear.birthYear }}</td>
            <td>{{ application.period.name }}</td>
            <td v-if="!workplaces.loading">
              <b-form-select id="workplace" name="workplace" v-model="applicationWorkplaces[application.id]">
                <option :value="null">-- Veldu starfsstað --</option>
                <template v-if="!workplaces.loading && workplaces.data">
                  <option
                    v-for="workplace in workplaces.data.filter(w => application.workplaces.some(aw => aw.workplace.id === w.id))"
                    :key="workplace.id"
                    :value="workplace.id"
                  >
                    {{ workplace.name }}
                  </option>
                </template>
              </b-form-select>
            </td>
            <td v-else>
              <b-spinner small></b-spinner>
            </td>
            <td v-if="!workplaces.loading">
              <b-form-select id="group" name="group" v-model="applicationWorkplaceGroups[application.id]">
                <option :value="null">-- Veldu hóp --</option>
                <template v-if="!workplaces.loading">
                  <option v-for="group in filteredGroups(application)" :key="group.uuid" :value="group.uuid">
                    {{ group.name }}
                  </option>
                </template>
              </b-form-select>
            </td>
            <td v-else>
              <b-spinner small></b-spinner>
            </td>
            <td>
              <i
                v-if="application.status !== 'NEW' && application.status !== 'IN_PROGRESS'"
                class="fa fa-exclamation-triangle"
                v-b-tooltip.hover
                title="Ekki er hægt að merkja umsókn í vinnslu"
              ></i>
            </td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { djangoErrorsToVee } from '@/utils';

export default {
  name: 'application-in-progress-modal',
  data() {
    return {
      loading: false,
      applications: [],
      workplaceGroups: [],
      workplaces: {
        data: [],
        loading: false,
        error: false,
      },
      applicationWorkplaces: {},
      applicationWorkplaceGroups: {},
    };
  },
  computed: {
    allNew() {
      return this.applications.every(a => a.status === 'NEW' || a.status === 'IN_PROGRESS');
    },
  },
  methods: {
    async validateBeforeSubmit() {
      try {
        this.errorList = [];
        const promises = [];

        this.applications.forEach(a => {
          promises.push(
            this.$applicationApi.applicationChangeStatus({
              uuid: a.id,
              applicationChangeStatusRequest: {
                status: 'IN_PROGRESS',
                workplace: this.applicationWorkplaces[a.id],
                group: this.applicationWorkplaceGroups[a.id],
              },
            }),
          );
        });
        await Promise.all(promises);
        this.$emit('successful', {});
        this.$refs.createModal.hide();
      } catch (e) {
        // Aðgerð mistókst.
        this.saving = true;
        this.$log.debug(e);
        if (e.response && e.response.status === 400) {
          djangoErrorsToVee(e.response.data, this.errors, this.errorList);
        } else {
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      }
    },
    filteredGroups(application) {
      const selectedWorkplace = this.applicationWorkplaces[application.id];
      if (!selectedWorkplace) {
        return [];
      }
      const workplace = this.workplaces.data.find(w => w.id === selectedWorkplace);
      if (!workplace) {
        return [];
      }
      const groups = workplace.groups.filter(group => {
        return group.periodUuid === application.period.id;
      });

      const applicationPeriodParts = application.periodParts;

      const periodGroups = groups.filter(group => {
        return applicationPeriodParts.some(periodPart => {
          return group.periodPartUuid === periodPart.periodPart.id;
        });
      });

      return periodGroups;
    },
    filterGroupsToPeriod(groups, period) {
      return groups.filter(group => group.period.id === period.id);
    },
    show(applications) {
      this.loadWorkplaces();
      this.applicationWorkplaces = applications.reduce((result, item) => {
        // eslint-disable-next-line no-param-reassign
        result[item.id] = null;
        return result;
      }, {});
      this.applications = applications;
      this.$refs.createModal.show();
    },
    async loadWorkplaces() {
      this.workplaces.loading = true;
      this.workplaces.data = [];
      this.workplaces.error = false;

      try {
        const workplaceList = await this.$coreApi.workplaceDropdownList();
        const selectedPeriod = this.applications[0].period.id; // TODO: Might be different for each application
        // Filter the groups within each workplace based on the selected period
        this.workplaces.data = workplaceList.data.map(workplace => {
          return {
            ...workplace,
            groups: workplace.groups.filter(group => group.periodUuid === selectedPeriod),
          };
        });

        this.workplaceGroups = workplaceList.data.map(workplace => {
          return workplace.groups.filter(group => group.periodUuid === selectedPeriod);
        });
      } catch (e) {
        this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
        this.workplaces.error = true;
      } finally {
        this.workplaces.loading = false;
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>
